import React from 'react'

/**
 * Shared loading indicator: an orange spinning wheel with an optional label.
 *
 * Use this anywhere a page or section is waiting to load so the loading
 * experience stays consistent across the app.
 *
 * Props:
 *  - label:   text shown next to the spinner (e.g. "Loading race calendar…")
 *  - compact: render the compact blue inline bar variant (small, left-aligned)
 *  - inline:  render just the spinner + text inline (no min-height block)
 *  - className: extra classes appended to the container
 */
export default function Loader({ label = 'Loading…', compact = false, inline = false, className = '' }) {
  const classes = [
    'loader',
    compact ? 'loader--compact' : '',
    inline ? 'loader--inline' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={classes} role="status">
      <span className={`loader__spinner${inline ? ' loader__spinner--inline' : ''}`} aria-hidden="true" />
      {label ? <span className="loader__label">{label}</span> : null}
    </div>
  )
}
